import stageDB from "../db/stageDB";

const getStageDOByStageNumberAndToothGumType = (stageNumber, toothGumType) => {
  return stageDB.getStageDOFromStageNumberAndToothGumType(
    stageNumber,
    toothGumType,
  );
};

const getStageList = () => {
  return stageDB.getStageDOList();
};

const validLastStage = (stageNumber) => {
  const stageDOList = stageDB.getStageDOList();
  return stageDOList[stageDOList.length - 1].stageNumber === stageNumber;
};

export default {
  getStageDOByStageNumberAndToothGumType,
  getStageList,
  validLastStage,
};
